<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-clipboard-list"></i> GED - Tipo de Atividades</h3>
      </div>
    </div>
    <GedTipoTarefaAdd v-if="showAdd" ref="GedTipoTarefaAdd" v-on:Back="onBack" />
    <GedTipoTarefaList v-else ref="GedTipoTarefaList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import GedTipoTarefaAdd from './components/add/gedtipotarefadd.vue'
import GedTipoTarefaList from './components/list/gedtipotarefalist.vue'

export default {
  name: 'GedTipoTarefa',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    GedTipoTarefaAdd,
    GedTipoTarefaList
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.GedTipoTarefaAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/gedtipotarefa/gedtipotarefa.vue